// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"U5-z","displaySixCardTiles":"V5-z"};